module.exports = __webpack_public_path__ + "static/media/team-member-elise.0758a54d.JPG";